import { StateCreator } from "zustand";

import { IUser, IUserSlice } from "../models";
import { ISelectOption } from "shared/models";
import { sliceResetFns } from "store";

const initialState = {
  user: {},
  userMentionOptions: [],
};

export const createUserSlice: StateCreator<
  IUserSlice,
  [["zustand/devtools", never]],
  [],
  IUserSlice
> = (set) => {
  sliceResetFns.add(() => set(initialState));
  return {
    ...initialState,
    setUser: (user: IUser) =>
      set((state) => ({
        user: {
          ...state.user,
          ...user,
        },
      })),
    setUserMentionOptions: (userMentionOptions: ISelectOption[]) =>
      set(() => ({
        userMentionOptions,
      })),
    resetUserSlice: () => set(() => initialState),
  };
};
